// src/api/useFetchObjectsWithConfig.js
import { useQuery } from "@tanstack/react-query";
import axios from "axios";

const useFetchObjectsWithConfig = (
  queryKey,
  endpoint,
  token,
  deviceConfig,
  options = {}
) => {
  const fetchFunction = async () => {
    const headers = {
      ...(token ? { Authorization: `Token ${token}` } : {}),
      "Content-Type": "application/json",
    };

    const response = await axios.post(
      `${process.env.REACT_APP_API_URL}/${endpoint}`,
      deviceConfig,
      { headers }
    );
    return response.data;
  };

  const { data, isLoading, isError, isSuccess, error, refetch } = useQuery({
    queryKey,
    queryFn: fetchFunction,
    ...options,
  });

  return { data, isLoading, isError, isSuccess, error, refetch };
};

export default useFetchObjectsWithConfig;
